import { render, staticRenderFns } from "./V2SegmentTags.vue?vue&type=template&id=4398c38a&scoped=true&"
import script from "./V2SegmentTags.vue?vue&type=script&lang=js&"
export * from "./V2SegmentTags.vue?vue&type=script&lang=js&"
import style0 from "./V2SegmentTags.vue?vue&type=style&index=0&id=4398c38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398c38a",
  null
  
)

export default component.exports